import Severity$1 from '../../../base/common/severity.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';

var Severity = Severity$1;
const INotificationService = createDecorator('notificationService');
class NoOpNotification {
}

export { INotificationService, NoOpNotification, Severity };
